<template>
<div class="div">
    <div class="statement">
        <ul id="lists" v-for="item in model" :key="item.id">
           <li>
            <p class="text">{{item.store}}</p>
            <p class="uite">{{item.count}}</p>
            </li>
        </ul>
    </div>
</div>
</template>
<script>
export default {
  name: "component_name",
  data () {
    return {
        model:[]
    };
  },
   created: function () {

        this.$http.get("/api/member/totalByRole").then(res => {
             if(res.data.errorCode == 100){
                 this.model=res.data.data;
             }
          console.log('res: ', res);

            // alert(JSON.stringify(res.body))
        })
    }
}
</script>
<style lang="css" scoped>
 ul li p {
        display: inline-block;
        font-size: 2rem;
    }

    ul li {
        border-bottom: 1px solid #e4e4e4;
        height: 3.4rem;
        line-height: 3.4rem;
        padding-right: 1rem;
    }

    .text {
        font-size: 1.8rem;
        font-weight: 700;

        padding-left: 20px;
      height: 37px;
        width: 66.45%;
    }
    .div{
        height:100%;
        overflow:scroll;
    }
    .uite {
        font-size: 1.8rem;
        width: 30%;
        text-align: right;
        /*padding-right: 1rem;*/

        border-left: 1px solid #666;
    }

    li:nth-child(even) p:nth-child(2) {
        background: #f8f8f8;
    }
</style>



// WEBPACK FOOTER //
// Report.vue?519c1a30